// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Date from "../Data.Date/index.js";
import * as Data_Date_Component from "../Data.Date.Component/index.js";
import * as Data_DateTime from "../Data.DateTime/index.js";
import * as Data_DateTime_Instant from "../Data.DateTime.Instant/index.js";
import * as Data_Enum from "../Data.Enum/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_CodePoints from "../Data.String.CodePoints/index.js";
import * as Data_String_CodeUnits from "../Data.String.CodeUnits/index.js";
import * as Data_Time from "../Data.Time/index.js";
import * as Data_Time_Component from "../Data.Time.Component/index.js";
import * as DateUtils from "../DateUtils/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Now from "../Effect.Now/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble from "../Unscramble/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var sub = /* #__PURE__ */ Data_Numeric.sub(Data_Numeric.additiveInt);
var fromEnum = /* #__PURE__ */ Data_Enum.fromEnum(Data_Enum.boundedEnumChar);
var add = /* #__PURE__ */ Data_Numeric.add(Data_Numeric.additiveInt);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var toEnum = /* #__PURE__ */ Data_Enum.toEnum(Data_Date_Component.boundedEnumYear);
var toEnum1 = /* #__PURE__ */ Data_Enum.toEnum(Data_Date_Component.boundedEnumMonth);
var toEnum2 = /* #__PURE__ */ Data_Enum.toEnum(Data_Date_Component.boundedEnumDay);
var toEnum3 = /* #__PURE__ */ Data_Enum.toEnum(Data_Time_Component.boundedEnumHour);
var toEnum4 = /* #__PURE__ */ Data_Enum.toEnum(Data_Time_Component.boundedEnumMinute);
var toEnum5 = /* #__PURE__ */ Data_Enum.toEnum(Data_Time_Component.boundedEnumSecond);
var toEnum6 = /* #__PURE__ */ Data_Enum.toEnum(Data_Time_Component.boundedEnumMillisecond);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Maybe.applicativeMaybe);
var map = /* #__PURE__ */ Data_Functor.map(Effect.functorEffect);
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var bind1 = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity));
var decode = /* #__PURE__ */ Foreign_Generic_Class.decode(Foreign_Generic_Class.stringDecode);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity));
var fail = /* #__PURE__ */ Foreign.fail(Data_Identity.monadIdentity);
var UTCTime = function (x) {
    return x;
};
var toFillFormTypeUTCTime = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("string");
    }
};
var unscrambleDecodeUTCTime = {
    unsafeDecode: function (value) {
        var str = Unscramble.decodeString(value);
        var v = DateUtils.parseISODateTime(str);
        if (v instanceof Data_Maybe.Just) {
            return v.value0;
        };
        if (v instanceof Data_Maybe.Nothing) {
            return Unscramble.decodingError("Invalid ISO8601 datetime: " + show(str));
        };
        throw new Error("Failed pattern match at Data.UTCTime (line 47, column 7 - line 49, column 78): " + [ v.constructor.name ]);
    }
};
var parseYYYYMMDDhhmmssDateTime = function (dateTime) {
    var digitToInt = function (c) {
        return sub(fromEnum(c))(fromEnum("0"));
    };
    var fromString = function (s) {
        var v = Data_String_CodeUnits.toCharArray(s);
        if (v.length === 4) {
            return new Data_Maybe.Just(add(add(add(digitToInt(v[0]) * 1000 | 0)(digitToInt(v[1]) * 100 | 0))(digitToInt(v[2]) * 10 | 0))(digitToInt(v[3])));
        };
        if (v.length === 2) {
            return new Data_Maybe.Just(add(digitToInt(v[0]) * 10 | 0)(digitToInt(v[1])));
        };
        return Data_Maybe.Nothing.value;
    };
    var v = Data_String_CodePoints.splitAt(4)(dateTime);
    var v1 = Data_String_CodePoints.splitAt(2)(v.after);
    var v2 = Data_String_CodePoints.splitAt(2)(v1.after);
    var v3 = Data_String_CodePoints.splitAt(2)(v2.after);
    var v4 = Data_String_CodePoints.splitAt(2)(v3.after);
    return bind(bind(fromString(v.before))(toEnum))(function (year) {
        return bind(bind(fromString(v1.before))(toEnum1))(function (month) {
            return bind(bind(fromString(v2.before))(toEnum2))(function (day) {
                return bind(bind(fromString(v3.before))(toEnum3))(function (hour) {
                    return bind(bind(fromString(v4.before))(toEnum4))(function (minute) {
                        return bind(bind(fromString(v4.after))(toEnum5))(function (second) {
                            return bind(toEnum6(0))(function (milliseconds) {
                                return bind(Data_Date.exactDate(year)(month)(day))(function (date) {
                                    return pure(new Data_DateTime.DateTime(date, new Data_Time.Time(hour, minute, second, milliseconds)));
                                });
                            });
                        });
                    });
                });
            });
        });
    });
};
var ordUTCTime = Data_DateTime.ordDateTime;
var now = function (dictMonadEffect) {
    return Effect_Class.liftEffect(dictMonadEffect)(map(function ($71) {
        return UTCTime(Data_DateTime_Instant.toDateTime($71));
    })(Effect_Now.now));
};
var newtypeUTCTime = {
    Coercible0: function () {
        return undefined;
    }
};
var showUTCTime = {
    show: function ($72) {
        return DateUtils.formatISODateTime(unwrap($72));
    }
};
var toUnixTimestamp = function ($73) {
    return unwrap(Data_DateTime_Instant.unInstant(Data_DateTime_Instant.fromDateTime(unwrap($73))));
};
var genericUTCTime = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var fromUTCTime = function (v) {
    return v;
};
var eqUTCTime = Data_DateTime.eqDateTime;
var encodeUTCTime = {
    encode: /* #__PURE__ */ (function () {
        var $74 = Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode);
        return function ($75) {
            return $74(DateUtils.formatISODateTime(unwrap($75)));
        };
    })()
};
var decodeUTCTime = {
    decode: function (value) {
        return bind1(decode(value))(function (str) {
            var v = DateUtils.parseISODateTime(str);
            if (v instanceof Data_Maybe.Just) {
                return pure1(v.value0);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return fail(new Foreign.ForeignError("Invalid ISO8601 datetime: " + show(str)));
            };
            throw new Error("Failed pattern match at Data.UTCTime (line 38, column 5 - line 40, column 84): " + [ v.constructor.name ]);
        });
    }
};
var boundedUTCTime = Data_DateTime.boundedDateTime;
export {
    UTCTime,
    fromUTCTime,
    now,
    parseYYYYMMDDhhmmssDateTime,
    toUnixTimestamp,
    genericUTCTime,
    newtypeUTCTime,
    eqUTCTime,
    ordUTCTime,
    boundedUTCTime,
    showUTCTime,
    decodeUTCTime,
    unscrambleDecodeUTCTime,
    encodeUTCTime,
    toFillFormTypeUTCTime
};
